import highlights from 'helpers/highlights';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoginButton from '../../Header/LoginButton';
import { useState } from 'react';

export default function TfHighlights({ topFill }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="tw-bg-primary-100 tw-relative tw-py-4">
        <div className="container containerInvisibleOnMobile tw-mt-20 mb-4">
          <div className="tw-max-w-2xl tw-mx-auto tw-text-center">
            <h2 className="tw-text-2xl tw-font-bold tw-leading-tight tw-text-gray-900 sm:tw-text-3xl lg:tw-text-4xl">
              {topFill ? '' : 'Got your name? '}Start your travel blog{' '}
              <span className="tw-break-inside-avoid">on TravelFeed!</span>
            </h2>
          </div>
          <div className="container-fluid tw-mt-8">
            <div className="row">
              {highlights.map(({ icon, title, description }) => {
                return (
                  <div
                    key={title}
                    className="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 pb-3"
                  >
                    <div className="d-flex">
                      {icon && (
                        <div className="tw-text-primary-800 p-1">
                          <FontAwesomeIcon
                            style={{ width: '45px', height: '45px' }}
                            icon={icon}
                          />
                        </div>
                      )}
                      <div className="pl-3">
                        <div className="tw-text-xl tw-font-semibold tw-leading-tight tw-text-primary-800">
                          {title}
                        </div>
                        <div className="pt-1 tw-text-base tw-text-gray-600">
                          {description}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="tw-flex">
            <div
              className="tw-mx-auto tw-px-10 tw-py-4 tw-text-base tw-font-semibold tw-text-white tw-transition-all tw-duration-200 tw-bg-primary-500 hover:tw-bg-primary-600 focus:tw-bg-primary-600 tw-cursor-pointer tw-rounded"
              role="button"
              onClick={() => setOpen(true)}
              tabIndex={0}
            >
              Start your travel blog
            </div>
          </div>
        </div>
        {/* 1px overlap + block: iOS Safari antialiases layer edges at fractional
            device pixels, which shows the background as a hairline seam */}
        <div className="tw-pointer-events-none tw-absolute -tw-top-px tw-z-10 -tw-mb-12 tw-w-full sm:-tw-mb-16">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
            className="tw-block tw-h-12 tw-w-full sm:tw-h-16"
          >
            <path
              d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
              className={topFill || 'tw-fill-gray-50'}
            ></path>
          </svg>
        </div>
        <div className="tw-pointer-events-none tw-absolute tw-bottom-px tw-z-10 -tw-mb-12 tw-w-full sm:-tw-mb-16">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
            className="tw-block tw-h-12 tw-w-full sm:tw-h-16"
          >
            <path
              d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
              className="tw-fill-primary-100"
            ></path>
          </svg>
        </div>
      </div>
      {open && (
        <LoginButton
          open={open}
          hideButtons
          onClickClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
